import createLogger from '@sfly/aurora-js-logger';
import { buildConfig } from '../config/buildConfig.js';
import { getEnvConfig } from './commonUtil.js';

const globalLogData = {} as any;
// Ignore eslint error for Webpack.DefinePlugin environment variables
// if (process.env.CI_BUILD_UUID) {
//   globalLogData.appVersion = process.env.CI_BUILD_UUID;
// } else {
//   globalLogData.appVersion = 'local-dev-version';
// }
const env = getEnvConfig();
export const logger = createLogger({
  name: 'cart-slidein-mfe',
  globalLogData,
  enableNRD: true,
  batchInterval: 1000,
  batchSize: 10,
  env: env.appEnv as 'dev' | 'stage' | 'production',
  apiKey: env.cartApiKey,
});

export function logError(message: string, eventType: string, fields: any = {}) {
  logger.error({
    logEvents: [
      {
        eventType,
        message,
      },
    ],
    appContext: {
      ...fields,
    },
  });
}

export function logInfo(message: string, eventType: string, fields: any = {}) {
  logger.info({
    logEvents: [
      {
        eventType,
        message,
      },
    ],
    appContext: {
      ...fields,
    },
  });
}
